import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { IncidentCard } from './IncidentCard';
import { EmptyState } from './EmptyState';
import type { Incident } from '../types';
import { ANIMATION_VARIANTS } from '../constants';

interface IncidentsListProps {
    incidents: Incident[];
    isLoading: boolean;
}

export const IncidentsList: React.FC<IncidentsListProps> = ({
    incidents,
    isLoading
}) => {
    if (isLoading) {
        return (
            <div className="px-[18px] space-y-3">
                {[...Array(4)].map((_, i) => (
                    <div
                        key={i}
                        className="bg-[var(--bg-elevated)] border border-[var(--border)] rounded-xl p-4 h-[100px] animate-pulse"
                    >
                        <div className="flex items-start gap-3">
                            <div className="w-10 h-10 rounded-lg bg-[var(--bg)]" />
                            <div className="flex-1 space-y-2">
                                <div className="h-4 bg-[var(--bg)] rounded w-3/4" />
                                <div className="h-3 bg-[var(--bg)] rounded w-1/2" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    if (incidents.length === 0) {
        return (
            <div className="px-[18px]">
                <EmptyState />
            </div>
        );
    }

    return (
        <motion.div
            variants={ANIMATION_VARIANTS.container}
            initial="hidden"
            animate="visible"
            className="px-[18px] space-y-3"
        >
            <AnimatePresence mode="popLayout">
                {incidents.map((incident, index) => (
                    <IncidentCard
                        key={incident.id}
                        incident={incident}
                        index={index}
                    />
                ))}
            </AnimatePresence>
        </motion.div>
    );
};